import { makeThemedComponent, media } from '@minerva-analytics/pantheon';
import { css } from 'styled-components';

const CardBody = makeThemedComponent({
  themeKey: `CardBody`,
  component: `div`,
  defaultStyles: css`
    padding: 2rem 2rem 3rem 2rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${media.tablet`
      padding: 2rem 1rem;
    `}
  `,
});

export default CardBody;
